<template>
  <div
    class="MR_envProRoadList"
    ref="MR_envProRoadList"
    @mouseleave="envProRoadLeave"
  >
    <el-table
      class="envProRoadListTable"
      :data="tableData"
      max-height="705px"
      @cell-mouse-enter="cursor"
      :header-cell-class-name="getHeaderCellClass"
      :header-row-class-name="getHeadRowClass"
      highlight-current-row
      :cell-class-name="getCellClass"
      :row-class-name="getRowClass"
      @row-click="rowClick"
    >
      <el-table-column type="index" width="70" label="序号"> </el-table-column>
      <el-table-column label="道路名" prop="roadName">
        <template #default="scope">
          <div class="boxLine">
            <div class="cellFont">
              {{ scope.row.roadName }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="道路等级" prop="roadTypeName">
        <template #default="scope">
          <div class="boxLine">
            <div class="cellFont">
              {{ scope.row.roadTypeName }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="riskLevel">
        <template #header>
          <el-tooltip
            popper-class="tooltipBox"
            class="tooltip-item"
            effect="dark"
            content="道路清洁度指数，表示道路干净程度，1-3颗星，星数越多，道路越干净"
            placement="top-start"
          >
            <div>道路清洁度指数</div>
          </el-tooltip>
        </template>
        <template #default="scope">
          <div class="star-box">
            <template
              v-for="item in Number(scope.row.riskLevel)
                ? Number(scope.row.riskLevel)
                : 0"
              :key="item"
            >
              <div v-if="Number(scope.row.riskLevel)" class="star"></div>
            </template>
            <template v-if="scope.row.riskLevel == '--'">
              <div class="no-star">{{ scope.row.riskLevel }}</div>
            </template>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <p v-if="nomore">没有更多数据了</p>
    <!-- </div> -->
  </div>
</template>

<script>
import { render } from "@vue/runtime-dom";
import environmentalProtectionRoad from "@/modules/mathRoadComponents/environmentalProtectionRoad/index.vue";
import { mapGetters } from "vuex";
import {
  RoadHeatLineFunc,
  HideHeatLineFunc,
  ShowHeatLineFunc,
} from "@/assets/js/unity3D/index.js";

export default {
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'MR_envProRoadList.vue',
      computedName: '环保道路清单组件',
      customerId: this.$store.state.customerId,
      tableData: [],
      setTime1: null,
      nomore: false,
      currentPage: 10,
      showRoadTimer: null,
      showRoadTimer2: null,
      tableDataJsonParse: [],

      isRoadStatus: false,
    };
  },
  inject: ["updateRoadStatus"],
  //计算属性 类似于data概念
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    getHeaderCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return "thClass_";
        } else {
          return "thClass";
        }
      };
    },

    getHeadRowClass() {
      return function (obj) {
        return "headTrClass";
      };
    },

    getCellClass() {
      return function (obj) {
        if (obj.columnIndex === 0) {
          return "tdClass_";
        } else {
          return "tdClass";
        }
      };
    },

    getRowClass() {
      return function (obj) {
        return "trClass";
      };
    },
    getRoadValue() {
      return (value) => {
        let roadStatus = [
          {
            status: "干燥",
            value: 100,
          },
          {
            status: "中等",
            value: 60,
          },
          {
            status: "湿润",
            value: 20,
          },
        ];
        let arr = roadStatus.filter((i) => i.status == value);
        if (arr[0]) {
          return arr[0].value;
        } else {
          return 100;
        }
      };
    },
  },
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.MR_envProRoadList).outerWidth();
    let h = $(that.$refs.MR_envProRoadList).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getListData();
  },

  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
    }
    if (this.showRoadTimer) {
      clearTimeout(this.showRoadTimer);
    }
    if (this.showRoadTimer2) {
      clearTimeout(this.showRoadTimer2);
    }
  },
  //方法集合
  methods: {
    envProRoadLeave() {
      $(".MR_envProRoadList .el-table__body-wrapper").removeClass("show");
      let ts = new Date().getTime();
      if (this.showRoadTimer) {
        clearTimeout(this.showRoadTimer);
      }
      this.updateRoadStatus(ts);
    },
    cursor(row, column, cell, event) {
      //document.title = "2333333";
      $(".MR_envProRoadList .el-table__body-wrapper").addClass("show");
      if (this.showRoadTimer) {
        clearTimeout(this.showRoadTimer);
      }
      let that = this;
      let ii = row;
      this.showRoadTimer = setTimeout(() => {
        /*let obj2 = JSON.parse(JSON.stringify(that.tableDataJsonParse));
        let HLJson = obj2.map((item) => {
          if (item.roadID == ii.modelId) {
            item.value = that.getRoadValue(ii.dryWetStatus);
            return item;
          } else {
            item.value = -1;
            return item;
          }
        });
        RoadHeatLineFunc(JSON.stringify(HLJson));
        ShowHeatLineFunc();*/
      }, 100);
    },
    rowClick(obj) {
      let obj2 = JSON.parse(JSON.stringify(this.tableDataJsonParse));
      let HLJson = obj2.map((item) => {
        if (item.roadID == obj.modelId) {
          item.value = this.getRoadValue(obj.dryWetStatus);
          return item;
        } else {
          item.value = -1;
          return item;
        }
      });
      console.log(HLJson, obj, "hljson");
      RoadHeatLineFunc(JSON.stringify(HLJson));
      ShowHeatLineFunc();
      let that = this._.appContext.app;
      this.$popup.close(that, "epr_wrap-style");
      this.$nextTick(() => {
        this.$store.commit("dialogStatus", true);
        this.$popup.open(
          environmentalProtectionRoad,
          this.dialogCompontent,
          {},
          {
            ...obj,
          }
        );
        this.$nextTick(() => {
          // $(this.dialogCompontent).addClass("epr_style");
        });
      });
    },
    rowHover(i) {
      if (this.showRoadTimer) {
        clearTimeout(this.showRoadTimer);
      }
      let that = this;
      let ii = i;
      this.showRoadTimer = setTimeout(() => {
        let obj2 = JSON.parse(JSON.stringify(that.tableDataJsonParse));
        let HLJson = obj2.map((item) => {
          if (item.roadID == ii.modelId) {
            item.value = that.getRoadValue(ii.dryWetStatus);
            return item;
          } else {
            item.value = -1;
            return item;
          }
        });
        RoadHeatLineFunc(JSON.stringify(HLJson));
        ShowHeatLineFunc();
      }, 500);
    },
    rowLeave() {
      if (this.showRoadTimer2) {
        clearTimeout(this.showRoadTimer2);
      }
      this.showRoadTimer2 = setTimeout(() => {
        HideHeatLineFunc();
      }, 500);
    },
    async getListData() {
      let that = this;
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      try {
        const getRoadInfoList =
          CONFIG.requestName + this.$apiOpt.getRoadInfoList;
        let res = await this.$apiUtils.get(getRoadInfoList, {
          customerId: this.customerId,
        });
        if (res) {
          this.tableData = res;
          let AllJson = new Array(65);
          for (let i = 0; i < AllJson.length; i++) {
            AllJson[i] = { roadID: "42_" + (i + 1), value: 30 };
          }
          this.tableDataJsonParse = AllJson;
        }
      } catch (err) {
        console.log(err);
      }
      this.setTime1 = setTimeout(() => {
        this.getListData();
      }, 1000 * 60 * 5);
    },
  },
  beforeUnmount() {
    if ($(this.dialogCompontent).length > 0) {
      $(this.dialogCompontent).removeClass("epr_style");
    }
  },
};
</script>
<style lang="scss" scoped>
.MR_envProRoadList {
  height: 790px;
  width: 600px;
  pointer-events: all;
  padding-top: 62px !important;
  :deep(.envProRoadListTable) {
    background: #01132d40 !important;
    pointer-events: all;
    .boxLine {
      width: 100%;
    }
    .thClass {
      background: #01122ba6 !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass > .cell {
      font-size: 16px !important;
      color: #47ffddff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
    }
    .thClass_ {
      background: #01122ba6 !important;
      border-right: 1px solid rgba(132, 170, 255, 0.5) !important;
      border-bottom: 1px solid #cccccc28 !important;
    }

    .thClass_ > .cell {
      font-size: 16px !important;
      color: #bbbbbbff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
    }
    .tdClass {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #01122b66 !important;
    }
    .tdClass > .cell {
      font-size: 16px !important;
      color: #bbbbbbff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      display: flex;
      justify-content: space-evenly;
      align-items: center;
    }
    .tdClass > .cell > .star-box {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;
    }
    .tdClass_ {
      border-right: 1px solid #84aaff40 !important;
      border-bottom: 1px solid #84aaff40 !important;
      background: #0b336b40 !important;
    }

    .tdClass_ > .cell > div {
      font-size: 16px !important;
      color: #888888ff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .headTrClass {
      border: 1px solid rgba(132, 170, 255, 0.5) !important;
    }
    .star {
      @include bg-box(14px, 14px, "star.png");
    }
    .no-star {
      font-size: 16px;
      color: #888888ff !important;
    }
    .tooltip-item {
      color: #47ffddff !important;
    }
    .cellFont {
      font-size: 16px !important;
      color: #888888ff !important;
      font-family: "fontNormal" !important;
      text-align: center !important;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-table__body-wrapper {
      &::-webkit-scrollbar {
        width: 0px !important;
      }
    }
    .el-table__body-wrapper.show {
      &::-webkit-scrollbar {
        width: 10px !important;
      }
    }
  }
}
</style>
<style>
.tooltipBox {
  color: rgb(244, 196, 143) !important;
  background: black;
  border: 2px rgb(57, 123, 247) solid;
}
.tooltipBox .el-popper__arrow::before {
  margin-top: 1px;
  border-bottom: 2px rgb(57, 123, 247) solid;
  border-right: 2px rgb(57, 123, 247) solid;
  box-sizing: border;
}
</style>
